import List from "@/components/list";
import Bus from "../Bus";

const Table = args => {
  const { listeners } = args;
  const RCSelectionChange = listeners["selection-change"] || function() {};
  //补交作业
  function handleUploadWork({ row }) {
    Bus.$emit("uploadWork", row);
  }

  const Deal = ({ props: { vo } }) => {
    const studentWork = vo.row;
    const dealConf = [
      [
        studentWork.finishStatus == 0
          ? "icon-upload-file"
          : "icon-upload-file-disable",
        "补交作业",
        studentWork.finishStatus == 0
          ? () => {
              handleUploadWork(vo);
            }
          : () => {},
        "studentWork:uploadWork"
      ]
      /*    [
      "icon-upload-file",
          "补交作业",
          () => handleUploadWork(vo),
          "studentWork:uploadWork"
      ]*/
    ];
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const UploadTime = ({ props: { vo } }) => {
    const uploadTime = vo.row.uploadTime ? vo.row.uploadTime : "--";
    return <span>{uploadTime}</span>;
  };

  const AttachmentName = ({ props: { vo } }) => {
    const attachmentName = vo.row.attachmentName ? vo.row.attachmentName : "--";
    return <span>{attachmentName}</span>;
  };

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main"
    },
    {
      label: "姓名",
      prop: "userName",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "工作单位",
      prop: "deptName",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "单位及职务",
      prop: "unitPosition",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "获得学分",
      prop: "credit",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "完成情况",
      prop: "finishStatusName",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "上传时间",
      prop: "uploadTime",
      minWidth: "120",
      showOverflowTooltip: true,
      render: vo => <UploadTime vo={vo} />
    },
    {
      label: "附件",
      prop: "attachmentName",
      minWidth: "120",
      showOverflowTooltip: true,
      render: vo => <AttachmentName vo={vo} />
    },
    {
      label: "操作",
      fixed: "right",
      minWidth: "80",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <List
      {...args}
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
